module.exports = __webpack_public_path__ + "static/media/Ben_Manley_Resume.cd188049.pdf";